import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Modal, NativeSyntheticEvent, Platform } from 'react-native';

import isFunction from 'utils/function';

import DialogBody from './components/DialogBody';
import { DialogProps } from './types';

const DialogView = ({
    animationType,
    style,
    title,
    titleStyle,
    titleTestID,
    titleNumberOfLines,
    description,
    DescriptionComponent,
    descriptionNumberOfLines,
    CloseComponent,
    IconComponent,
    errorCode,
    visible = true,
    actionButtonBordered,
    actionButtonTitle,
    actionButtonFillColor,
    actionButtonStyle,
    actionButtonTextStyle,
    actionButtonOnPress,
    actionButtonTestID,
    actionButtonAccessibilityLabel,
    cancelButtonTitle,
    cancelButtonFillColor,
    cancelButtonOnPress,
    cancelButtonBordered,
    cancelButtonStyle,
    cancelButtonAccessibilityLabel,
    revertButtons,
    supportedOrientation,
    descriptionTestID,
    closeButtonTestID,
    cancelButtonTextStyle,
    errorCodeTestID,
    fromPlayer,
    onRequestClose,
}: DialogProps) => {
    useEffect(() => {
        // TODO: commented out because of freezes
        // dispatch(setBlockFullscreen());
    }, []);

    const [modalVisible, setModalVisible] = useState(true);

    const handleCancelPress = useCallback(() => {
        if (isFunction(cancelButtonOnPress)) {
            // TODO: commented out because of freezes
            // dispatch(setUnblockFullscreen());
            cancelButtonOnPress();
        }
    }, [cancelButtonOnPress]);

    const handleActionButtonPress = useCallback(() => {
        if (isFunction(actionButtonOnPress)) {
            // TODO: commented out because of freezes
            // dispatch(setUnblockFullscreen());
            actionButtonOnPress();
        }
    }, [actionButtonOnPress]);

    const timeout = useRef<NodeJS.Timeout | undefined | null>(undefined);

    const previousOrientation = useRef<string>('portrait');

    useEffect(() => {
        if (!modalVisible) {
            if (timeout.current) {
                clearTimeout(timeout.current);
                timeout.current = null;
            }

            timeout.current = setTimeout(() => {
                setModalVisible(true);
            }, 1000);
        }

        return () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
                timeout.current = null;
            }
        };
    }, [modalVisible]);

    const handleModalOrientationChange = useCallback(
        (event: NativeSyntheticEvent<any>) => {
            if (Platform.OS === 'ios') {
                if (
                    event.nativeEvent.orientation === 'portrait' &&
                    event.nativeEvent.orientation !==
                        previousOrientation.current
                ) {
                    setModalVisible(false);
                }

                previousOrientation.current = event.nativeEvent.orientation;
            }
        },
        [],
    );

    return (
        <Modal
            onRequestClose={onRequestClose || cancelButtonOnPress}
            visible={visible && modalVisible}
            supportedOrientations={supportedOrientation}
            onOrientationChange={handleModalOrientationChange}
            animationType={animationType}
            statusBarTranslucent
            transparent
        >
            <DialogBody
                descriptionTestID={descriptionTestID}
                titleTestID={titleTestID}
                style={style}
                title={title}
                titleStyle={titleStyle}
                titleNumberOfLines={titleNumberOfLines}
                description={description}
                DescriptionComponent={DescriptionComponent}
                descriptionNumberOfLines={descriptionNumberOfLines}
                errorCode={errorCode}
                actionButtonBordered={actionButtonBordered}
                actionButtonTestID={actionButtonTestID}
                actionButtonTitle={actionButtonTitle}
                actionButtonFillColor={actionButtonFillColor}
                actionButtonStyle={actionButtonStyle}
                actionButtonTextStyle={actionButtonTextStyle}
                actionButtonAccessibilityLabel={actionButtonAccessibilityLabel}
                cancelButtonTitle={cancelButtonTitle}
                cancelButtonFillColor={cancelButtonFillColor}
                cancelButtonBordered={cancelButtonBordered}
                cancelButtonStyle={cancelButtonStyle}
                cancelButtonAccessibilityLabel={cancelButtonAccessibilityLabel}
                closeButtonTestID={closeButtonTestID}
                cancelButtonTextStyle={cancelButtonTextStyle}
                handleCancelPress={handleCancelPress}
                handleActionButtonPress={handleActionButtonPress}
                revertButtons={revertButtons}
                errorCodeTestID={errorCodeTestID}
                IconComponent={IconComponent}
                fromPlayer={fromPlayer}
            />
            {CloseComponent ? <CloseComponent /> : null}
        </Modal>
    );
};

export default DialogView;
